import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import Service from 'ember-simple-auth/services/session';
import type { User } from 'frontend-payments/models';

export interface AuthenticatedSessionData {
  authenticator: string;
}

export interface PaymentsSessionData {
  authenticated: AuthenticatedSessionData;
}

export default class SessionService extends Service<PaymentsSessionData> {
  @service declare errorTracking: Services['error-tracking'];
  @service declare store: Services['store'];

  @tracked isPayByLinkOpened = false;
  @tracked user: User | null = null;

  loadUserTask = task({}, async (): Promise<void> => {
    try {
      const user = (await this.store.queryRecord('user', {})) as User;

      this.user = user;
    } catch (error) {
      this.errorTracking.captureException(error);
      throw error;
    }
  });

  /**
   * Checks if the current authenticated user is a staff user
   * Staff users have @mylighthouse.com email addresses
   */
  get isStaffUser(): boolean {
    const email = this.user?.email;

    if (!email) {
      return false;
    }

    return email.endsWith('@mylighthouse.com');
  }

  closePayByLink(): void {
    this.isPayByLinkOpened = false;
  }

  openPayByLink(): void {
    this.isPayByLinkOpened = true;
  }
}

declare module '@ember/service' {
  interface Registry {
    session: SessionService;
  }
}
